import { TOrderAttributeTypes, TRESPONSE_ORDER_ATTRIBUTES } from '@monorepo/types';

export type TOrderAttributesState = {
  OrderAttributesInfo: TRESPONSE_ORDER_ATTRIBUTES | null;
  OrderAttributesTypesInfo: TOrderAttributeTypes[] | null;
};

export const TOrderAttributesInfoActionType = {
  GetOrderAttributes: 'GET_ORDER_ATTRIBUTES' as const,
  GetOrderAttributesSuccess: 'GET_ORDER_ATTRIBUTES_SUCCESS' as const,
  GetOrderAttributesFailure: 'GET_ORDER_ATTRIBUTES_FAILURE' as const,
  GetOrderAttributesTypes: 'GET_ORDER_ATTRIBUTES_TYPES' as const,
  GetOrderAttributesTypesSuccess: 'GET_ORDER_ATTRIBUTES_TYPES_SUCCESS' as const,
  GetOrderAttributesTypesFailure: 'GET_ORDER_ATTRIBUTES_TYPES_FAILURE' as const,
  AddUpdateOrderAttributes: 'ADD_UPDATE_ORDER_ATTRIBUTES' as const,
  AddUpdateOrderAttributesSuccess: 'ADD_UPDATE_ORDER_ATTRIBUTES_SUCCESS' as const,
  AddUpdateOrderAttributesFailure: 'ADD_UPDATE_ORDER_ATTRIBUTES_FAILURE' as const,
  DeleteOrderAttributes: 'DELETE_ORDER_ATTRIBUTES' as const,
  DeleteOrderAttributesSuccess: 'DELETE_ORDER_ATTRIBUTES_SUCCESS' as const,
  DeleteOrderAttributesFailure: 'DELETE_ORDER_ATTRIBUTES_FAILURE' as const,
};
